import api from './api'

export const hrmEmployeesApi = {
  getCreateData: (): Promise<any> => api.get('/employees/create'),
  getAll: (params: Record<string, any> = {}): Promise<any> => api.get('/employees', { params }),
  getById: (id: number | string): Promise<any> => api.get(`/employees/${id}`),
  create: (data: Record<string, any>): Promise<any> => api.post('/employees', data),
  update: (id: number | string, data: Record<string, any>): Promise<any> => data instanceof FormData
    ? api.post(`/employees/${id}`, data)
    : api.put(`/employees/${id}`, data),
  delete: (id: number | string): Promise<any> => api.delete(`/employees/${id}`),
  deleteBySelection: (selectedIds: (number | string)[]): Promise<any> => api.post('/employees/delete/by_selection', { selectedIds }),
  getEmployeesSelect: (): Promise<any> => api.get('/employees/get/select'),
  getUnpaidCustodies: (params: Record<string, any> = {}): Promise<any> => api.get('/get_unpaid_custodies', { params }),
  updateSocialProfile: (id: number | string, data: Record<string, any>): Promise<any> => api.put(`/update_social_profile/${id}`, data),
}

export const attendanceApi = {
  getAll: (params: Record<string, any> = {}): Promise<any> => api.get('/attendances', { params }),
  getById: (id: number | string): Promise<any> => api.get(`/attendances/${id}`),
  getCreateData: (): Promise<any> => api.get('/attendances/create'),
  create: (data: Record<string, any>): Promise<any> => api.post('/attendances', data),
  update: (id: number | string, data: Record<string, any>): Promise<any> => api.put(`/attendances/${id}`, data),
  delete: (id: number | string): Promise<any> => api.delete(`/attendances/${id}`),
  deleteBySelection: (data: Record<string, any>): Promise<any> => api.post('/attendances/delete/by_selection', data),
}

export const departmentsApi = {
  getByCompany: (id: number | string): Promise<any> => api.get('/core/get_departments_by_company', { params: { id } }),
  getAll: (params: Record<string, any> = {}): Promise<any> => api.get('/departments', { params }),
  getById: (id: number | string): Promise<any> => api.get(`/departments/${id}`),
  getCreateData: (): Promise<any> => api.get('/departments/create'),
  getEditData: (id: number | string): Promise<any> => api.get(`/departments/${id}/edit`),
  create: (data: Record<string, any>): Promise<any> => api.post('/departments', data),
  update: (id: number | string, data: Record<string, any>): Promise<any> => api.put(`/departments/${id}`, data),
  delete: (id: number | string): Promise<any> => api.delete(`/departments/${id}`),
  deleteBySelection: (selectedIds: (number | string)[]): Promise<any> => api.post('/departments/delete/by_selection', { selectedIds }),
}

export const designationsApi = {
  getByDepartment: (id: number | string): Promise<any> => api.get('/core/get_designations_by_department', { params: { id } }),
  getAll: (params: Record<string, any> = {}): Promise<any> => api.get('/designations', { params }),
  getById: (id: number | string): Promise<any> => api.get(`/designations/${id}`),
  getCreateData: (): Promise<any> => api.get('/designations/create'),
  getEditData: (id: number | string): Promise<any> => api.get(`/designations/${id}/edit`),
  create: (data: Record<string, any>): Promise<any> => api.post('/designations', data),
  update: (id: number | string, data: Record<string, any>): Promise<any> => api.put(`/designations/${id}`, data),
  delete: (id: number | string): Promise<any> => api.delete(`/designations/${id}`),
  deleteBySelection: (selectedIds: (number | string)[]): Promise<any> => api.post('/designations/delete/by_selection', { selectedIds }),
}

export const holidaysApi = {
  getAll: (params: Record<string, any> = {}): Promise<any> => api.get('/holiday', { params }),
  getById: (id: number | string): Promise<any> => api.get(`/holiday/${id}`),
  create: (data: Record<string, any>): Promise<any> => api.post('/holiday', data),
  update: (id: number | string, data: Record<string, any>): Promise<any> => api.put(`/holiday/${id}`, data),
  delete: (id: number | string): Promise<any> => api.delete(`/holiday/${id}`),
  getCreateData: (): Promise<any> => api.get('/holiday/create'),
  getEditData: (id: number | string): Promise<any> => api.get(`/holiday/${id}/edit`),
  deleteBySelection: (selectedIds: (number | string)[]): Promise<any> => api.post('/holiday/delete/by_selection', { selectedIds }),
}

export const leaveTypesApi = {
  getAll: (params: Record<string, any> = {}): Promise<any> => api.get('/leave_type', { params }),
  getById: (id: number | string): Promise<any> => api.get(`/leave_type/${id}`),
  create: (data: Record<string, any>): Promise<any> => api.post('/leave_type', data),
  update: (id: number | string, data: Record<string, any>): Promise<any> => api.put(`/leave_type/${id}`, data),
  delete: (id: number | string): Promise<any> => api.delete(`/leave_type/${id}`),
}

export const officeShiftsApi = {
  getByCompany: (id: number | string): Promise<any> => api.get('/core/get_office_shift_by_company', { params: { id } }),
  getAll: (params: Record<string, any> = {}): Promise<any> => api.get('/office_shift', { params }),
  getById: (id: number | string): Promise<any> => api.get(`/office_shift/${id}`),
  create: (data: Record<string, any>): Promise<any> => api.post('/office_shift', data),
  update: (id: number | string, data: Record<string, any>): Promise<any> => api.put(`/office_shift/${id}`, data),
  delete: (id: number | string): Promise<any> => api.delete(`/office_shift/${id}`),
  getCreateData: (): Promise<any> => api.get('/office_shift/create'),
  getEditData: (id: number | string): Promise<any> => api.get(`/office_shift/${id}/edit`),
  deleteBySelection: (selectedIds: (number | string)[]): Promise<any> => api.post('/office_shift/delete/by_selection', { selectedIds }),
}

export const hrmCompaniesApi = {
  getAll: (params: Record<string, any> = {}): Promise<any> => api.get('/company', { params }),
  getById: (id: number | string): Promise<any> => api.get(`/company/${id}`),
  create: (data: Record<string, any>): Promise<any> => api.post('/company', data),
  update: (id: number | string, data: Record<string, any>): Promise<any> => api.put(`/company/${id}`, data),
  delete: (id: number | string): Promise<any> => api.delete(`/company/${id}`),
  deleteBySelection: (selectedIds: (number | string)[]): Promise<any> => api.post('/company/delete/by_selection', { selectedIds }),
}

export const leavesApi = {
  getAll: (params: Record<string, any> = {}): Promise<any> => api.get('/leave', { params }),
  getById: (id: number | string): Promise<any> => api.get(`/leave/${id}`),
  create: (data: Record<string, any>): Promise<any> => api.post('/leave', data),
  update: (id: number | string, data: Record<string, any>): Promise<any> => api.put(`/leave/${id}`, data),
  delete: (id: number | string): Promise<any> => api.delete(`/leave/${id}`),
  getCreateData: (): Promise<any> => api.get('/leave/create'),
  getEditData: (id: number | string): Promise<any> => api.get(`/leave/${id}/edit`),
  deleteBySelection: (selectedIds: (number | string)[]): Promise<any> => api.post('/leave/delete/by_selection', { selectedIds }),
}

export const leaveListsApi = {
  getAll: (params: Record<string, any> = {}): Promise<any> => api.get('/leave_lists', { params }),
  getById: (id: number | string): Promise<any> => api.get(`/leave_lists/${id}`),
  create: (data: Record<string, any>): Promise<any> => api.post('/leave_lists', data),
  update: (id: number | string, data: Record<string, any>): Promise<any> => api.put(`/leave_lists/${id}`, data),
  delete: (id: number | string): Promise<any> => api.delete(`/leave_lists/${id}`),
}

export const coreApi = {
  getEmployeesByCompany: (id: number | string): Promise<any> => api.get(`/core/get_employees_by_company?id=${id}`),
  getDepartmentsByCompany: (id: number | string): Promise<any> => api.get(`/core/get_departments_by_company?id=${id}`),
  getEmployeesByDepartment: (id: number | string): Promise<any> => api.get(`/get_employees_by_department?id=${id}`),
  getDesignationsByDepartment: (id: number | string): Promise<any> => api.get(`/core/get_designations_by_department?id=${id}`),
  getOfficeShiftByCompany: (id: number | string): Promise<any> => api.get(`/core/get_office_shift_by_company?id=${id}`),
}

export const workExperienceApi = {
  getByEmployee: (employeeId: number | string, params: Record<string, any> = {}): Promise<any> => api.get(`/get_experiences_by_employee?id=${employeeId}`, { params }),
  create: (data: Record<string, any>): Promise<any> => api.post('/work_experience', data),
  update: (id: number | string, data: Record<string, any>): Promise<any> => api.put(`/work_experience/${id}`, data),
  delete: (id: number | string): Promise<any> => api.delete(`/work_experience/${id}`),
}

export const employeeAccountsApi = {
  getByEmployee: (employeeId: number | string, params: Record<string, any> = {}): Promise<any> => api.get(`/get_accounts_by_employee?id=${employeeId}`, { params }),
  create: (data: Record<string, any>): Promise<any> => api.post('/employee_account', data),
  update: (id: number | string, data: Record<string, any>): Promise<any> => api.put(`/employee_account/${id}`, data),
  delete: (id: number | string): Promise<any> => api.delete(`/employee_account/${id}`),
}

// Namespaced, NOT spread: hrmEmployeesApi, attendanceApi, leavesApi,
// leaveListsApi, holidaysApi, ... all declare getAll/getById/create/update/
// delete, so the old flat merge silently let the last spread win —
// `hrmApi.getAll()` hit /leave_lists, `hrmApi.create()` posted to
// /employee_account. Every group is also exported on its own; import those
// directly (or use the namespaced pair) instead.
export const hrmApi = {
  employees: hrmEmployeesApi,
  attendance: attendanceApi,
  departments: departmentsApi,
  designations: designationsApi,
  holidays: holidaysApi,
  leaveTypes: leaveTypesApi,
  officeShifts: officeShiftsApi,
  companies: hrmCompaniesApi,
  leaves: leavesApi,
  leaveLists: leaveListsApi,
  core: coreApi,
  workExperience: workExperienceApi,
  employeeAccounts: employeeAccountsApi,
}

export const attendanceAggregationApi = {
  getMonthlySummary: (params: Record<string, any>): Promise<any> => api.get('/attendance-aggregation/monthly-summary', { params }),
  getEmployeeDetail: (employeeId: number | string, params: Record<string, any>): Promise<any> => api.get(`/attendance-aggregation/employee-detail/${employeeId}`, { params }),
  getDepartmentTotals: (params: Record<string, any>): Promise<any> => api.get('/attendance-aggregation/department-totals', { params }),
}

export const overtimeApprovalApi = {
  getPending: (params: Record<string, any> = {}): Promise<any> => api.get('/overtime-approvals', { params }),
  create: (data: Record<string, any>): Promise<any> => api.post('/overtime-approvals', data),
  approve: (id: number | string): Promise<any> => api.post(`/overtime-approvals/${id}/approve`),
  reject: (id: number | string, data: Record<string, any>): Promise<any> => api.post(`/overtime-approvals/${id}/reject`, data),
  getHistory: (params: Record<string, any>): Promise<any> => api.get('/overtime-approvals/history', { params }),
}

export default hrmApi;
